import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";

const SliderContainer = styled.div`
  width:100%;
  background-color: white;
  padding-bottom: 2em;
`;

const Slide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
  max-height: 700px;
  object-fit: cover;

`;

const images = [
  "https://eupha-ca.com/static/media/event-eupha.png",
  "https://eupha-ca.com/static/media/event-eupha.png",
  "https://eupha-ca.com/static/media/event-eupha.png",
];

const PhotoSlider = () => {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
    };
  
    return (
      <SliderContainer>
        <Slider {...settings}>
          {images.map((img, index) => (
            <Slide key={index}>
              <Image src={img} alt={`Slide ${index}`} />
            </Slide>
          ))}
        </Slider>
      </SliderContainer>
    );
  };
  
  export default PhotoSlider;